<div class="container-fluid">
    <div class="row">
        <div class="alignMenu shadow text-left pt-2 px-1"
            [ngClass]="companyId == 36 ? 'col-md-3 col-lg-2' : 'col-lg-2 col-xl-2'">
            <app-rental-menu (companyIdSevenMile)="companyIdSevenMile($event)"></app-rental-menu>
        </div>
        <div class="bgMainSection bgBlue text-left"
            [ngClass]="companyId == 36 ? 'col-md-9 col-lg-10' : 'col-lg-10 col-xl-10'">
            <div class="container mainContainer">
                <div class="row">
                    <div class="col-5 text-left mt-4">
                        <h2 class="mainHeading">News</h2>
                    </div>
                    <div class="col-7 text-right mt-4" [ngClass]="{'col-lg-5': SwapORamaCustomChanges}">
                        <h1 class="mainHeading">{{marketName}}</h1>
                    </div>
                    <div class="col-12 col-lg-2 text-left text-lg-right mt-4" *ngIf="SwapORamaCustomChanges">
                        <a class="text-white language-toggle translator" style="text-decoration: none !important;" translate="no" href="javascript:void(0)" onclick="toggleLanguage()">Español</a>
                    </div>
                </div>
                <div class="bgWghite shadow mt-2">
                    <div *ngFor="let data of filteredNews let i = index;">
                        <div class="container">
                            <div class="row pt-4 pb-3">
                                <div class="col-sm-12 col-md-12 col-lg-10 col-xl-10 text-start">
                                    <span class="newsHeading mt-2">{{data.NewsTitle}}</span>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-2 col-xl-2 text-start">
                                    <button class="btn btn-primary" data-toggle="modal" data-target="#modalReadMore"
                                        (click)="openModal(data)">Read More</button>
                                </div>
                            </div>
                        </div>
                        <hr class="my-0" />
                    </div>
                    <div class="container" [hidden]="this.NewsData.length<=4">
                        <div class="row">
                            <div class="col-12 text-start my-3">
                                <a style="font-size: 15px; color: #0056b3;" (click)="loadMoreNews()">
                                    <span style="text-decoration: underline !important;">{{label}}</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal Read More-->
    <!-- <div class=".d_box modal fade" id="modalReadMore" tabindex="-1" role="dialog" aria-labelledby="modalReadMoreTitle"
        aria-hidden="true">
        <div class="d_box modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body py-5">
                    <h5 class="justify fw-700">{{selectedNews?.NewsTitle}}</h5>
                    <label class="justify mt-2" style="font-size: 16px;">{{selectedNews?.Description}}</label>
                </div>
            </div>
        </div>
    </div> -->

    <div class="modal fade" id="modalReadMore" tabindex="-1" role="dialog" aria-labelledby="modalReadMoreTitle"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-lg" style="width: 100%;" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <span class="modal-title" id="modalReadMoreTitle" style="font-size: 18px;">
                        <b>{{selectedNews?.NewsTitle}}</b>
                    </span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!-- <p class="mt-2" style="font-size: 16px; white-space: pre-wrap;">{{selectedNews?.Description}}</p> -->
                    <div class="container">
                        <div class="row">
                            <div class="ccol-12 text-left mt-2">
                                <div [innerHTML]="this.sanitizer.bypassSecurityTrustHtml(selectedNews?.Description)">
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 col-lg-8 col-xl-8 text-left mt-2"
                                *ngIf="selectedNews?.ImageUrl1 && selectedNews?.ImageUrl1">
                                <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                                    <div class="carousel-inner">
                                        <div class="carousel-item active" *ngIf="selectedNews?.ImageUrl1">
                                            <img class="img-fluid d-block w-100" [src]="selectedNews?.ImageUrl1"
                                                alt="First slide">
                                        </div>
                                        <div class="carousel-item" *ngIf="selectedNews?.ImageUrl2">
                                            <img class="img-fluid d-block w-100" [src]="selectedNews?.ImageUrl2"
                                                alt="Second slide">
                                        </div>
                                        <!-- <div class="carousel-item">
                                        <img class="d-block w-100" src="https://www.spaceathand.com/Images/header-VehicleStorage.webp" alt="Third slide">
                                    </div> -->
                                    </div>
                                    <a class="carousel-control-prev" href="#carouselExampleControls" role="button"
                                        data-slide="prev">
                                        <span class="carousel-control-prev-icon" aria-hidden="true"
                                            style="color: gray;"></span>
                                        <span class="sr-only">Previous</span>
                                    </a>
                                    <a class="carousel-control-next" href="#carouselExampleControls" role="button"
                                        data-slide="next">
                                        <span class="carousel-control-next-icon" aria-hidden="true"
                                            style="color: gray;"></span>
                                        <span class="sr-only">Next</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- Modal Read More Ends Here-->
</div>